import { render, staticRenderFns } from "./html-editor.vue?vue&type=template&id=7065bf06&"
import script from "./html-editor.vue?vue&type=script&lang=ts&"
export * from "./html-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports